import { API } from '../../../api'

export const createAddress = (
  address: API.orders_view_order_billingAddress | API.orders_view_order_shippingAddress,
) => Object.entries(address).reduce((acc, [key, value]) => `${acc}${key}: ${value}<br/>`, '')
